const r = {
  color: {
    background: "#f9fafaff",
    progressFrom: "#b9edbd",
    progressTo: "#47c47d"
  }
};
export {
  r as progressBar
};
